import PageContainer from "@/components/PageContainer/PageContainer";

export default PageContainer;
